import { render, staticRenderFns } from "./SabbaticalCompensateDetail.vue?vue&type=template&id=3e7050f3&scoped=true&"
import script from "./SabbaticalCompensateDetail.vue?vue&type=script&lang=js&"
export * from "./SabbaticalCompensateDetail.vue?vue&type=script&lang=js&"
import style0 from "./SabbaticalCompensateDetail.vue?vue&type=style&index=0&id=3e7050f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7050f3",
  null
  
)

export default component.exports